import { INVALID_PHONE_MESSAGE } from '../../constants/messages';
import { cleanPhone } from '../phone';
export var validatePhone = function validatePhone(phone) {
  var phoneRegExp = /^\d{10}$/;
  return phoneRegExp.test(cleanPhone(phone)) ? undefined : INVALID_PHONE_MESSAGE;
};